import "./InsuranceDirectPay.css"
import React, {Component} from 'react'
import {DateNavigation} from "../../../../components/datenavigation/DateNavigation";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import PageTitle from "../../../../layout/PageTitle";
import DateUtil from "../../../../utils/DateUtil";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import moment from "moment";
import {Button, Col, Container, Dropdown, Row, SplitButton} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {DateInput, FileUploader, Modal, NumberInput, TextareaInput, TextInput} from "../../../../components";
import {Dropdown as PrimeDropdown} from "primereact/components/dropdown/Dropdown";
import dialog from "../../../../components/dialog/Dialog";
import AttachmentModal from "../../../emr/recordpage/treatment/utils/AttachmentModal";
import {noop, pick} from "lodash-es";
import InsuranceDocuments from "../InsuranceDocuments";
import EnumDirectBillingType from "./EnumDirectBillingType";
import InsuranceDocumentLegend from "../InsuranceDocumentLegend";
import NotificationService, {showNotification} from "../../../../services/notification-service/NotificationService";
import ObservationsModal from "../observation/ObservationsModal";
import ViewObservationsModal from "../observation/ViewObservationsModal";
import DirectBillingItemStatusEnum from "../../enums/DirectBillingItemStatusEnum";
import DirectBillingItemAuthorizationStatusEnum from "../../enums/DirectBillingItemAuthorizationStatusEnum";
import Tooltip from "../../../../components/tooltip/Tooltip";
import ActionMenu from "../../../../components/action-menu/ActionMenu";
import ActionMenuItem from "../../../../components/action-menu/ActionMenuItem";
import ResubmissionsModal from "../resubmission/ResubmissionsModal";
import VersionModal from "../component/VersionModal";
import InsuranceReferralModal from "../referral/InsuranceReferralModal";
import DirectBillingReferralTypeEnum from "../../enums/DirectBillingReferralTypeEnum";
import InsuranceReferralStatus from "../../enums/InsuranceReferralStatus";
import EnumCoPayUnit from "../../enums/EnumCoPayUnit";
import ObjectUtil from "../../../../utils/ObjectUtil";
import PreApprovalDetailMultipleEditModal from "./PreApprovalDetailMultipleEditModal";
import HoverableDescriptionBox from "../../../../components/hoverable-desc-box/HoverableDescriptionBox";
import NoteListModal from "../notes/NoteListModal";
import MoneyUtil from "../../../../utils/MoneyUtil";

export default class InsuranceDirectPay extends Component {
    constructor(props) {
        super(props);

        this.referralModal = React.createRef();

        this.state = {
            sendToOptions: [],
            items: [],
            expandedItems: [],
            selectedItem: null,
            errorMessages: [],
            selectedDate: null,
            dbItems: [],
            notesModalVisible: false,
        }
    }

    componentDidMount() {
        this.retrieveStaffs();
        this.retrieveClinics();
        if (this.props.selected) {
            this.retrieveItems();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.selected && this.props.selected) {
            this.retrieveItems(this.state.selectedDate == null ? undefined : this.state.selectedDate);
        }
    }

    handleDateStateChange = (date) => {
        this.retrieveItems(date);
        this.setState({selectedDate: date});
    }

    retrieveStaffs() {
        RemotingService.getRemoteCall('api/staff/list-base', null, (result) => {
            const staffs = result.items;
            staffs.forEach(i => {
                i.key = "" + i.id;
            });
            const sendToOptions = [
                {name: 'Insurance', key: 'INSURANCE'},
                {name: 'Patient', key: 'PATIENT'},
                ...staffs,
                {name: 'Other', key: 'OTHER'}];
            this.setState({sendToOptions});
        });
    }

    retrieveClinics = () => {
        RemotingService.getRemoteCall('api/clinic/list', null, (result) => {
            this.setState({clinicOptions: result.items});
        });
    }

    retrieveItems(date = DateUtil.today()) {
        RemotingService.getRemoteCall(
            'api/insurance/coordinator/direct-billing',
            {
                date: moment(date).format('YYYY-MM-DD'),
            },
            (items) => {
                let dbItems = [];
                items.map(item => item.directBillingItemList.forEach(directBillingItem => dbItems.push(ObjectUtil.clone(directBillingItem))));
                this.setState({items, dbItems});
            });
    }

    checkDBForValidation = (db) => {
        const result = [];
        if(db.referenceNo == null) {
            result.push("Reference No.");
        }
        if (db.noOfApprovedSessions == null) {
            result.push("No. of Approved Sessions");
        }
        if (db.validUntil == null) {
            result.push("Valid Until");
        }
        if (db.sendTo == null) {
            result.push("Send To");
        }
        return result;
    }

    checkDBItemForValidation = (item) => {
        const result = [];
        if (item.coPay == null) {
            result.push("Co-Pay");
        }
        if (item.coPayMax == null) {
            result.push("Max Co-Pay");
        }
        if (item.coPayUnit == null) {
            result.push("Co-Pay Unit");
        }
        if (item.authorizationStatus == null) {
            result.push("Insurance Response Status");
        }
        return result;
    }

    updateItem = (item, updatedField, newValue, callback = noop) => {
        if(updatedField === 'status' && newValue === 'APPROVED') {
            let emptyFields = this.checkDBForValidation(item);
            if(emptyFields.length > 0) {
                const validationMessage = `Direct Billing have missing fields: ${Array.prototype.join.call(emptyFields, ", ")}`
                showNotification({summary: 'Validation Error', detail: validationMessage, severity: 'warn'})
                return;
            }

            let shouldReturn = false;
            let attachedItems = this.state.dbItems.filter(dbItem => item.directBillingItemList.some(item => dbItem.id === item.id));
            attachedItems && attachedItems.map(dbItem => {
                const emptyFields = this.checkDBItemForValidation(dbItem);
                if(emptyFields.length > 0) {
                    const validationMessage = `${dbItem.cpt.cptCode} have missing fields: ${Array.prototype.join.call(emptyFields, ", ")}`
                    showNotification({summary: 'Validation Error', detail: validationMessage, severity: 'warn'})
                    shouldReturn = true;
                }
            })

            if(shouldReturn){
                return;
            }
        }
        const updateDto = pick(item,
            ['claimFormStatus', 'medicalReportStatus', 'speciality', 'status', 'sendTo', 'referenceNo',
                'noOfApprovedSessions', 'validUntil', 'notes', 'attachments']);

        updateDto[updatedField] = newValue;

        RemotingService.postRemoteCall(
            `api/insurance/coordinator/direct-billing/${item.id}`,
            updateDto,
            () => {
                item[updatedField] = newValue && Array.isArray(newValue) ? [...newValue] : newValue;
                callback();
                this.forceUpdate();
            }, null, true, false);
    }

    documentsTemplate = (item) => {
        return <InsuranceDocuments
            item={item}
            onClaimFormStatusChange={(newStatus) => this.updateItem(item, 'claimFormStatus', newStatus)}
            onMedicalReportStatusChange={(newStatus) => this.updateItem(item, 'medicalReportStatus', newStatus)}
        />
    }

    specialityTemplate = (item) => {
        if (DirectBillingReferralTypeEnum[item.referralType] === DirectBillingReferralTypeEnum.INTERNAL) {
            return this.listInputTemplate(item, 'speciality', EnumDirectBillingType.directPaySelectableTypes)
        } else {
            return <div>{EnumDirectBillingType[item.speciality].name}</div>
        }
    }

    cptTemplate(item) {
       if (DirectBillingReferralTypeEnum[item.referralType] === DirectBillingReferralTypeEnum.INTERNAL) {
           if (!item.referral || !item.referral.cptList || item.referral.cptList.length === 0) {
               return null;
           }
           return (
               <div className="hoverable-desc-box-list">
                   {item.referral.cptList.map((cpt, index) => (
                       <HoverableDescriptionBox key={index} header={cpt.cptCode} description={cpt.description} />
                   ))}
               </div>
           );
       } else {
           if (!item.externalReferral || !item.externalReferral.cptList || item.externalReferral.cptList.length === 0) {
               return null;
           }
           return (
               <div className="hoverable-desc-box-list">
                   {item.externalReferral.cptList.map((cpt, index) => (
                       <HoverableDescriptionBox key={index} header={cpt.cptCode} description={cpt.description} />
                   ))}
               </div>
           );
       }
    }

    authSessionsTemplate = (item) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '6px' }}>{item.noOfUsedSessions}</span>
                <span style={{ marginRight: '6px' }}>/</span>
                <NumberInput
                    value={item.noOfApprovedSessions}
                    min={0}
                    style={{
                        width: '35px',
                        height: '25px',
                        textAlign: 'center',
                        padding: '0',
                        lineHeight: '25px',
                        fontSize: '14px'
                    }}
                    onChange={(value) => {
                        this.updateItem(item, 'noOfApprovedSessions', value);
                    }}
                />
            </div>
        );
    }

    openAttachmentsModal = (item) => {
        dialog({
            title: "Attachments",
            component: <AttachmentModal
                visitId={item.visitId}
                files={item.attachments || []}
                saveAction={(files, dialogCloseFunc) => {
                    this.updateItem(item, 'attachments', files, () => {
                        dialogCloseFunc();
                        this.forceUpdate();
                    })
                }}/>
        });
    }

    dateTimeTemplate(data) {
         return DirectBillingReferralTypeEnum[data.referralType] === DirectBillingReferralTypeEnum.INTERNAL ?
           data.referral.startTime ? DateUtil.formatClinicDateTime(data.referral.startTime, "Do MMMM YYYY / hh:mm A") : ""
        : "N/A"
    }

    dateInputTemplate = (item, field) => {
        return (
            <DateInput className={"whiteBackground"} value={item[field]}
                       onChange={(value) => this.updateItem(item, field, value)}/>
        )
    }

    listInputTemplate = (item, field, options) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PrimeDropdown optionLabel="name" optionValue="key"
                               options={options}
                               tooltip={options.find(option => option.key === item[field])?.name}
                               tooltipOptions={{
                                   position: 'top',
                                   showDelay: 500,
                                   hideDelay: 300
                               }}
                               appendTo={document.body}
                               value={item[field]}
                               onChange={event => this.updateItem(item, field, event.value)}
                               style={{
                                   width: 120,
                                   height: 35,
                               }}
                />
            </div>
        )
    }

    textInputTemplate = (item, field) => {
        return (
            <div>
                <TextInput value={item[field]} style={{width: '100%'}}
                           onChange={value => this.updateItem(item, field, value)}/>
            </div>
        )
    }

    diagnosisTemplate(item) {
        if (DirectBillingReferralTypeEnum[item.referralType] === DirectBillingReferralTypeEnum.INTERNAL) {
            if (!item.internalReferral || !item.internalReferral.diagnosisGroup ||
                !item.internalReferral.diagnosisGroup.diagnosisItems || item.internalReferral.diagnosisGroup.diagnosisItems.length === 0) {
                return null;
            }

            // Sort diagnosis items to have PRINCIPAL first, then SECONDARY
            const sortedDiagnosisItems = [...item.internalReferral.diagnosisGroup.diagnosisItems].sort((a, b) => {
                if (a.level === "PRINCIPAL" && b.level !== "PRINCIPAL") return -1;
                if (a.level !== "PRINCIPAL" && b.level === "PRINCIPAL") return 1;
                return 0;
            });

            return (
                <div className="hoverable-desc-box-list">
                    {sortedDiagnosisItems.map((diagnosis, index) => (
                        <HoverableDescriptionBox
                            key={index}
                            header={diagnosis.level === "PRINCIPAL" ? `P: ${diagnosis.code}` : `S: ${diagnosis.code}`}
                            description={diagnosis.description}
                        />
                    ))}
                </div>
            );
        } else {
            if (!item.externalReferral || !item.externalReferral.icd) {
                return null;
            }

            return (
                <div>
                    <HoverableDescriptionBox
                        header={item.externalReferral.icd.code}
                        description={item.externalReferral.icd.description}
                    />
                </div>
            );
        }
    }

    referralTypeTemplate(directBillingItem) {
        return DirectBillingReferralTypeEnum[directBillingItem.referralType]?.name;
    }

    renderDirectBillingActions = (rowData) => {
        return this.isEditable(rowData) ? (<ActionMenu id="packagepanelactionmenu">
            <ActionMenuItem text="Edit Referral"
                            onClick={() => {
                               this.openExternalReferralModal(rowData.externalReferral , true , this.state.selectedDate)
                            }}/>
        </ActionMenu>)
            :
            null;
    }

    isEditable (rowData) {
        return DirectBillingReferralTypeEnum[rowData.referralType] === DirectBillingReferralTypeEnum.EXTERNAL;
    }

    rowClass(data) {
        const resultReturned = data.directBillingItemList ?
            data.directBillingItemList.filter(dbItem => dbItem.status === 'RESPONDED') : [];

        const approvedExternalReferral = DirectBillingReferralTypeEnum[data.referralType] === DirectBillingReferralTypeEnum.EXTERNAL &&  data.status === "APPROVED";

        return {
            'row-responded': resultReturned.length > 0 || approvedExternalReferral
        }
    }

    renderExternalReferralModal() {
        return <Modal visible={this.state.externalReferralModalVisible}
                      header="External Referral"
                      submitContent="Save"
                      submitAction={() => this.referralModal.current.save()}
                      closeAction={() => this.setState({externalReferralModalVisible: false})}
                      contentStyle={{minWidth: 400}}>
            <InsuranceReferralModal
                ref={this.referralModal}
                editMode={this.state.externalReferralEditable}
                selectedDate={this.state.externalReferralDate}
                referralItem={this.state.externalReferralItem}
                typeOptions ={EnumDirectBillingType.directPaySelectableTypes}
                sendToOptions={this.state.sendToOptions}
                clinicOptions={this.state.clinicOptions}
                onInsuranceReferralSaved={(date) => {
                    this.handleDateStateChange(date);
                    this.setState({externalReferralModalVisible: false})
                }}/>
        </Modal>
    }

    openExternalReferralModal = (externalReferral = {date: new Date()}, isEditMode = false, selectedDate = new Date()) => {
        this.setState({
            externalReferralModalVisible: true,
            externalReferralItem: externalReferral,
            externalReferralDate: selectedDate ?? DateUtil.today(),
            externalReferralEditable: isEditMode
        })
    }

    notesTemplate = (item) => {
        const notes = item.notes || [];
        const notesCount = notes.filter(i=> i.isActive).length;
        return (
            <Button
                variant="link"
                className="notes-button"
                onClick={() => this.openNoteListModal(item)}
            >
                <FontAwesomeIcon icon={["fas", "sticky-note"]} size={"sm"} className="mr-1"/>
                Notes ({notesCount})
            </Button>
        );
    }

    openNoteListModal = (item) => {
        this.setState({notesModalVisible: true, selectedItem: item});
    }

    closeNoteListModal = () => {
        this.setState({notesModalVisible: false, selectedItem: null});
        this.retrieveItems(this.state.selectedDate == null ? undefined : this.state.selectedDate) // fetch direct billings again
    }

    renderNoteListModal() {
        return this.state.notesModalVisible &&
            <Modal
                visible={this.state.notesModalVisible}
                header="Notes"
                closeAction={() => this.closeNoteListModal()}
                contentStyle={{minWidth: 600, minHeight: 400}}
            >
                <NoteListModal
                    directBillingId={this.state.selectedItem.id}
                />
            </Modal>
    }

    render() {
        let date = this.state.selectedDate ? this.state.selectedDate : DateUtil.today();

        return (
            <>

                <div style={{padding: '10px'}} className="data-table-header-wrapper">
                    <div className="float-left">
                        <PageTitle title="Pre Approval" className="bg-white"/>
                    </div>
                    <div className="float-right">
                        <DateNavigation date={date} onDateChange={this.handleDateStateChange} displayDate={true}/>
                    </div>
                </div>
                <div style={{padding: '10px'}} className="data-table-header-wrapper">
                    <div className="float-right" style={{display: "flex"}}>
                        <Button variant="success"
                                onClick={() => this.openExternalReferralModal()}>
                            Add External Referral
                        </Button>
                    </div>
                </div>
                <div style={{padding: '10px'}}>
                    <DataTable className="InsuranceTable"
                               emptyMessage={"No items found"}
                               value={this.state.items}
                               rows={20}
                               expandedRows={this.state.expandedItems}
                               rowExpansionTemplate={(item) => <PreApprovalDetail directBilling={item} retrieveItems={() => this.retrieveItems(date)} sendToOptions={this.state.sendToOptions}/>}
                               onRowToggle={(e) => this.setState({expandedItems: e.data})}
                               columnResizeMode="fit"
                               paginator={true}
                               scrollable
                               paginatorPosition="bottom"
                               style={{ maxWidth: '100%' }}
                               rowClassName={this.rowClass}
                    >
                        <Column expander headerStyle={{width: 30}} />
                        <Column header=" " body={this.documentsTemplate} headerStyle={{ width: '40px' }} />
                        <Column header="Referral Type" headerStyle={{ width: '60px' }} body={(item) => this.referralTypeTemplate(item)}/>
                        <Column header="Visit Date/Time" field="referral.startTime" sortable body={this.dateTimeTemplate} headerStyle={{ width: '120px' }}/>
                        <Column header="Speciality" field="speciality" style={{width: '120px', height: '60px'}} sortable body={(item) => this.specialityTemplate(item)}/>
                        <Column header="ICD Code" headerStyle={{width: '130px'}} body={(item) => this.diagnosisTemplate(item)}/>
                        <Column header="CPT Codes" body={this.cptTemplate} headerStyle={{ width: '180px' }}/>
                        <Column header="Req. Sessions" headerStyle={{width: '60px'}} body={(item) => item.noOfSessions} style={{width: '100px'}}/>
                        <Column header="Auth. Sessions" body={(item) => this.authSessionsTemplate(item)} style={{width: '100px'}}/>
                        <Column header="Ref No." body={(item) => this.textInputTemplate(item, 'referenceNo')} style={{width: '100px'}}/>
                        <Column header="Status" field="status" headerStyle={{ width: '120px' }} sortable body={(item) => this.listInputTemplate(item, 'status', InsuranceReferralStatus.toArray())}/>
                        <Column header="Send To" field="sendTo" sortable style={{width: '120px'}} body={(item) => this.listInputTemplate(item, 'sendTo', this.state.sendToOptions)}/>
                        <Column header="Date" field="date" headerStyle={{ width: '90px' }} body={(item) => moment(item.date).format('MM/DD/YYYY')}/>
                        <Column header="Valid From" field="date" headerStyle={{ width: '80px' }}  sortable body={(item) => this.dateInputTemplate(item, 'validFrom')}/>
                        <Column header="Valid To" field="date" headerStyle={{ width: '80px' }}  sortable body={(item) => this.dateInputTemplate(item, 'validUntil')}/>
                        <Column header="Patient" field="patientName" filter={true} filterMatchMode="contains" sortable headerStyle={{ width: '100px' }}/>
                        <Column header="ID Number" field="patientEid" headerStyle={{ width: '130px' }}/>
                        <Column header="MRN" field="patientMrn" filter={true} filterMatchMode="contains" sortable headerStyle={{ width: '90px' }}/>
                        <Column header="Insurance" field="patientInsurance" filter={true} filterMatchMode="contains" sortable headerStyle={{ width: '150px' }}/>
                        <Column header="Member Id" field="patientInsuranceMemberId" filter={true} filterMatchMode="contains" sortable headerStyle={{ width: '150px' }}/>
                        <Column header="Denial Code" headerStyle={{width: 120}}/>
                        <Column header="Comments" field="comments" headerStyle={{width: 200}}/>
                        <Column header="Notes" body={(item) => this.notesTemplate(item)} headerStyle={{width: '100px'}}/>
                        <Column header="Actions" body={this.renderDirectBillingActions.bind(this)} style={{textAlign: "center", width:"75px"}}/>
                    </DataTable>
                    <InsuranceDocumentLegend/>
                </div>

                {this.renderExternalReferralModal()}
                {this.renderNoteListModal()}
            </>
        )
    }
}

class PreApprovalDetail extends Component {

    constructor(props) {
        super(props);

        this.preApprovalModalRef = React.createRef();

        this.state = {
            selectedItems: [],
            claim: null,
            denialCodeList : [],
            internalComplaintModalVisible: false,
            correctionModalVisible: false,
            resubmission: {},
            resubmissionDbItem: {},
            resubmissionAttachment: null,
            currentVersion: null,
            dbItemConfirmationDTO: {}
        };

        this.confirmDetailsFields = [];
    }

    componentDidMount() {
        RemotingService.postRemoteCall(`api/insurance/coordinator/direct-billing/${this.props.directBilling.id}/retrieve-claim`, null, (claim) => {
            this.setState({claim})
        });

        RemotingService.getRemoteCall(`api/insurance/coordinator/denial-code/list`, null, (result) => {
            this.setState({denialCodeList : result})
        });
    }

    denialCodeDetails(code){
        for (let denialCode of this.state.denialCodeList) {
            if(denialCode.code === code)
                return denialCode.description;
        }
    }

    submitPriorRequest() {
        const dbItemIds = this.state.selectedItems.map(dbItem => dbItem.id);
        RemotingService.postRemoteCall(`api/insurance/coordinator/direct-billing/${this.props.directBilling.id}/prior-request`, dbItemIds, () => {
            this.props.retrieveItems();
        });
    }

    extendPriorRequest() {
        const dbItemIds = this.state.selectedItems.map(dbItem => dbItem.id);
        RemotingService.postRemoteCall(`api/insurance/coordinator/direct-billing/${this.props.directBilling.id}/extend-prior-request`, dbItemIds, () => {
            this.props.retrieveItems();
        });
    }

    cancelPriorRequest() {
        const dbItemIds = this.state.selectedItems.map(dbItem => dbItem.id);
        RemotingService.postRemoteCall(`api/insurance/coordinator/direct-billing/${this.props.directBilling.id}/cancel-prior-request`, dbItemIds, () => {
            this.props.retrieveItems();
        });
    }

    submitNewRequest() {
        const dbItemIds = this.state.selectedItems.map(dbItem => dbItem.id);
        RemotingService.postRemoteCall(`api/insurance/coordinator/direct-billing/${this.props.directBilling.id}/submit-new-request`, dbItemIds, () => {
            this.props.retrieveItems();
        });
    }

    observationTemplate(directBillingItem) {
        return (
            <div onClick={() => this.openObservationDialog(directBillingItem.id)}>
                <span className="text-break cursor-pointer mr-1"><u>Observations</u></span><FontAwesomeIcon icon="paperclip"/>
            </div>
        )
    }

    resubmisssionTemplate(directBillingItem) {
        return (
            <div onClick={() => this.openResubmissionDialog(directBillingItem.id)}>
                <span className="text-break cursor-pointer mr-1"><u>Resubmissions</u></span>
            </div>
        )
    }

    denialCodeTemplate(directBillingItem) {
        return (
            <Tooltip title={this.denialCodeDetails(directBillingItem.denialCode)}>
                <span>{directBillingItem.denialCode}</span>
            </Tooltip>
        )
    }

    referrerNameTemplate() {
        const {directBilling} = this.props;
        return DirectBillingReferralTypeEnum[directBilling.referralType] === DirectBillingReferralTypeEnum.INTERNAL ?
            directBilling.referral ? directBilling.referral.referrerName : '' :
            directBilling.externalReferral ? directBilling.externalReferral.referredBy : '';
    }

    providerNameTemplate() {
        const {directBilling} = this.props;
        return DirectBillingReferralTypeEnum[directBilling.referralType] === DirectBillingReferralTypeEnum.INTERNAL ?
            directBilling.referral.providerName
            : this.props.sendToOptions.filter(o => o.key === directBilling.externalReferral?.sendTo)[0]?.name;
    }

    observationFromInsuranceTemplate(directBillingItem) {
        return (
            <div onClick={() => this.openObservationFromInsuranceDialog(directBillingItem.id)}>
                <span className="text-break cursor-pointer mr-1"><u>Observations</u></span><FontAwesomeIcon
                icon="paperclip"/>
            </div>
        )
    }

    requestVersionTemplate(directBillingItem) {
        return (
            <div onClick={() => this.openVersionModal(directBillingItem.requestVersionList)}>
                <span className="text-break cursor-pointer mr-1"><u>Versions</u></span><FontAwesomeIcon icon="paperclip"/>
            </div>
        )
    }

   authorizationVersionTemplate(directBillingItem) {
        return (
            <div onClick={() => this.openVersionModal(directBillingItem.authorizationVersionList)}>
                <span className="text-break cursor-pointer mr-1"><u>Versions</u></span><FontAwesomeIcon icon="paperclip"/>
            </div>
        )
    }

    statusTemplate(directBillingItem) {
        return DirectBillingItemStatusEnum[directBillingItem.status]?.name;
    }

    openObservationDialog(directBillingItemId) {
        dialog({
            title: "Observations",
            component: <ObservationsModal directBillingItemId={directBillingItemId}/>
        });
    }

    openResubmissionDialog(directBillingItemId) {
        dialog({
            title: "Resubmissions",
            component: <ResubmissionsModal directBillingItemId={directBillingItemId}/>
        });
    }

    openObservationFromInsuranceDialog(directBillingItemId) {
        RemotingService.getRemoteCall(`api/insurance/coordinator/direct-billing-item/${directBillingItemId}/observation-from-insurance`, null, observations => {
            dialog({
                title: "Observations",
                component: <ViewObservationsModal observations={observations}/>
            });
        });
    }

    openVersionModal(versions) {
        dialog({
            title: "Versions",
            component: <VersionModal versions={versions}/>
        });
    }

    renderActions = (rowData) => {
        return (<ActionMenu id="packagepanelactionmenu">
            <ActionMenuItem text={"Internal Complaint"}
                            onClick={() => {
                                let updatedResubmission = this.state.resubmission;
                                updatedResubmission.type = 'INTERNAL_COMPLAINT';
                                this.setState({
                                    resubmission: updatedResubmission,
                                    internalComplaintModalVisible: true,
                                    resubmissionDbItem: rowData,
                                    currentVersion:
                                        rowData?.requestVersionList.length > 0 ?
                                            rowData.requestVersionList[rowData.requestVersionList.length-1] :
                                            null
                                })
                            }}/>
            <ActionMenuItem text="Correction"
                            onClick={() => {
                                let updatedResubmission = this.state.resubmission;
                                updatedResubmission.type = 'CORRECTION';
                                this.setState({
                                    resubmission: updatedResubmission,
                                    correctionModalVisible: true,
                                    resubmissionDbItem: rowData
                                })
                            }}/>

        </ActionMenu>)
    }

    submitInternalComplaint = () => {
        const parameters = {
            type: this.state.resubmission.type,
            comments: this.state.resubmission.comments,
            attachment: this.state.resubmissionAttachment,
            currentVersion: this.state.currentVersion
        }

        RemotingService.postRemoteCall(`api/insurance/coordinator/direct-billing/${this.props.directBilling.id}/submit-internal-complaint/${this.state.resubmissionDbItem.id}`, parameters, () => {
            this.props.retrieveItems();
            this.setState({resubmission: null});
        });
    };

    handleVersionChange = (currentVersion) => {
        this.setState({currentVersion})
    }

    renderInternalComplaintModal = () => {
        let versionOptions = this.state.resubmissionDbItem?.requestVersionList?.map(item => {
            return{
                ...item,
                label: "v 1."+item.version
            }
        })

        return (
            <>
                <Modal visible={this.state.internalComplaintModalVisible}
                       header="Prior Authorization Internal Complaint"
                       submitContent="Submit Prior Request"
                       submitAction={() => this.submitInternalComplaint()}
                       closeAction={() => this.setState({internalComplaintModalVisible: false})}
                       submitDisabled={this.state.resubmission?.comments == null || this.state.resubmission?.comments?.length <= 0 || this.state.currentVersion == null}
                       contentStyle={{width: "500px", height: "300px"}}>

                    <Container className={"InputModal"}>
                        <Row>
                            <Col xs={3} className="dim14-form-label">
                                Version
                            </Col>
                            <Col xs={9}>
                                <PrimeDropdown dataKey="id" optionLabel="label"
                                               options={versionOptions}
                                               value={this.state.currentVersion}
                                               appendTo={document.body}
                                               onChange={e => this.handleVersionChange(e.target.value)}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3} className="dim14-form-label">
                                Comments
                            </Col>
                            <Col xs={9}>
                                <TextareaInput style={{width: "100%", maxHeight: "100px"}}
                                               value={this.state.resubmission?.comments}
                                               onChange={(value) => {
                                                   let updatedResubmission = this.state.resubmission;
                                                   updatedResubmission.comments = value;
                                                   this.setState({resubmission: updatedResubmission})
                                               }}/>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={3} className="dim14-form-label">
                                File Attachment
                            </Col>
                            <Col xs={9}>
                                <FileUploader basic accept=".pdf"
                                              value={this.state.resubmissionAttachment}
                                              onChange={(file) => {
                                                  this.state.resubmissionAttachment = file;
                                                  this.state.resubmissionAttachment.contentType = file.mimeType;
                                                  this.state.resubmissionAttachment.data = file.content;
                                                  this.forceUpdate();
                                              }}/>
                            </Col>
                        </Row>
                    </Container>
                </Modal>
            </>
        )
    }

    confirmDetailFieldChange = (directBillingItem, field, value) => {
        directBillingItem[field] = value === "" ? null : value;
        this.setState({dbItemConfirmationDTO: directBillingItem});
    }

    dateTemplate(directBillingItem, fieldName) {
        return this.isDetailFieldEditable(directBillingItem) !== true ? DateUtil.formatDate(directBillingItem[fieldName])  :
            <div>
                <DateInput className={"whiteBackground"} value={directBillingItem[fieldName]}
                           onChange={(value) => this.confirmDetailFieldChange(directBillingItem, fieldName, value)}/>

            </div>
    }

    numberTemplate = (directBillingItem, fieldName) => {
        const isMoneyField = fieldName === 'coPay' || fieldName === 'coPayMax';
        return this.isDetailFieldEditable(directBillingItem) !== true ? directBillingItem[fieldName] :
            <div>
                <NumberInput value={directBillingItem[fieldName]} min={0} style={{width: '100%'}}
                             allowDecimal={isMoneyField}
                             maxFractionDigits={isMoneyField ? MoneyUtil.getFractionDigits(directBillingItem.coPayUnit) : undefined}
                             onChange={(value) => this.confirmDetailFieldChange(directBillingItem, fieldName, value)}/>

            </div>
    }

    dropdownTemplate = (directBillingItem, fieldName) => {
        if(fieldName === 'coPayUnit'){
            return this.isDetailFieldEditable(directBillingItem) !== true ? EnumCoPayUnit[directBillingItem[fieldName]] :
                <div>
                    <PrimeDropdown optionLabel="name" optionValue="key" style={{width: '100%'}}
                                   options={EnumCoPayUnit.toArray()}
                                   appendTo={document.body}
                                   value={directBillingItem[fieldName]}
                                   onChange={e => this.confirmDetailFieldChange(directBillingItem, 'coPayUnit', e.target.value)}/>
                </div>
        }

        if(fieldName === 'authorizationStatus'){
            return this.isDetailFieldEditable(directBillingItem) !== true ? DirectBillingItemAuthorizationStatusEnum[directBillingItem.authorizationStatus]?.name :
                <div>
                    <PrimeDropdown optionLabel="name" optionValue="key" style={{width: '100%'}}
                                   options={DirectBillingItemAuthorizationStatusEnum.toArray()}
                                   value={directBillingItem[fieldName]}
                                   appendTo={document.body}
                                   onChange={e => this.confirmDetailFieldChange(directBillingItem, 'authorizationStatus', e.target.value)}/>
                </div>
        }
    }

    isDetailFieldEditable = (directBillingItem) => {
        const {directBilling} = this.props;

        let respondedDirectBillingItems = directBilling.directBillingItemList ?
            directBilling.directBillingItemList.filter(dbItem => dbItem.status === 'RESPONDED') : [];

        return !((directBillingItem.isConfirmed != null && directBillingItem.isConfirmed === true) || respondedDirectBillingItems.length > 0);
    }

    confirmPreApprovalDetails = () => {
        if (this.preApprovalModalRef.current) {
            this.preApprovalModalRef.current.confirmDetails().then();
        }
    }

    isMultipleEditButtonEnabled = () => this.state.selectedItems.filter(i=>i.isConfirmed === false).length === 0;

    renderPreApprovalDetailMultipleEditModal = () => {
        return (
            <Modal visible={this.state.preApprovalDetailMultipleEditModalVisible}
                   header="Edit Multiple Cpt Items"
                   submitContent="Confirm Details"
                   submitAction={() => this.confirmPreApprovalDetails()}
                   closeAction={() => this.setState({preApprovalDetailMultipleEditModalVisible: false})}
                   contentStyle={{minWidth: 400}}>
                <PreApprovalDetailMultipleEditModal
                    ref={this.preApprovalModalRef}
                    selectedItems={(this.state.preApprovalDetailMultipleEditModalItems || []).filter(item => item.isConfirmed === false)}
                    onConfirm={() => this.props.retrieveItems(this.props.selectedDate == null ? undefined : this.props.selectedDate)}
                    />
            </Modal>
        )
    }

    openPreApprovalDetailMultipleEditModal = () => {
        this.setState(
            {
                preApprovalDetailMultipleEditModalVisible: true,
                preApprovalDetailMultipleEditModalItems: (this.state.selectedItems || []).filter(item => item.isConfirmed === false)
            }
        )
    }

    render() {
        const {directBilling} = this.props;
        let submitNewRequestIsVisible = this.state.claim?.invoice?.status !== "BILLED";

        return (
            <div className="p-4">
                <DataTable emptyMessage={"No items found"}
                           className="pre-approval-table"
                           value={directBilling.directBillingItemList}
                           columnResizeMode="fit"
                           scrollable
                           autoLayout
                           dataKey="id"
                           selection={this.state.selectedItems}
                           onSelectionChange={e => this.setState({selectedItems: e.value})}>
                    <Column selectionMode="multiple" headerStyle={{width: '3em'}}/>
                    <Column header="ID" field="id"/>
                    <Column header="CPT Code" body={item => <HoverableDescriptionBox header={item.cpt.cptCode} description={item.cpt.description}/>}/>
                    <Column header="Status" field="status" body={(directBillingItem) => this.statusTemplate(directBillingItem)}/>
                    <Column header="Co-Pay" body={(directBillingItem) => this.numberTemplate(directBillingItem, 'coPay')}/>
                    <Column header="Co-Pay Unit" body={(directBillingItem) => this.dropdownTemplate(directBillingItem, 'coPayUnit')}/>
                    <Column header="Max Co-Pay" body={(directBillingItem) => this.numberTemplate(directBillingItem, 'coPayMax')}/>
                    <Column header="Referred By" body={() => this.referrerNameTemplate()}/>
                    <Column header="Performing Clinician" body={() => this.providerNameTemplate()}/>
                    <Column header="Observation" body={(directBillingItem) => this.observationTemplate(directBillingItem)} headerStyle={{ width: '100px' }}/>
                    <Column header="Resubmission" body={(directBillingItem) => this.resubmisssionTemplate(directBillingItem)} headerStyle={{ width: '100px' }}/>
                    <Column header="Insurance Response Status" field="authorizationStatus" body={(directBillingItem) => this.dropdownTemplate(directBillingItem, 'authorizationStatus')}/>
                    <Column header="Denial Code" body={(directBillingItem) => this.denialCodeTemplate(directBillingItem)}/>
                    <Column header="Observation From Insurance" body={(directBillingItem) => this.observationFromInsuranceTemplate(directBillingItem)} headerStyle={{ width: '100px' }} />
                    <Column header="Comments" field="comments"/>
                    <Column header="Request Version" body={(directBillingItem) => this.requestVersionTemplate(directBillingItem)}/>
                    <Column header="Authorization Version" body={(directBillingItem) => this.authorizationVersionTemplate(directBillingItem)}/>
                    <Column header="Attachment" field=""/>
                    <Column header="Actions" body={this.renderActions} style={{textAlign: "center", width:"75px"}}/>
                </DataTable>
                <SplitButton
                    id="preApprovalActions"
                    className="mt-1 mr-2"
                    variant="success"
                    title="Submit Prior Request"
                    disabled={this.state.selectedItems.length === 0}
                    onClick={() => this.submitPriorRequest()}>
                    <Dropdown.Item onClick={() => this.extendPriorRequest()}>Extend Validity</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.cancelPriorRequest()}>Cancel Prior Request</Dropdown.Item>
                    {submitNewRequestIsVisible && <Dropdown.Item onClick={() => this.submitNewRequest()}>Submit New Request</Dropdown.Item>}
                </SplitButton>
                <Button className="mt-1"
                        variant="success"
                        disabled={this.isMultipleEditButtonEnabled()}
                        onClick={() => this.openPreApprovalDetailMultipleEditModal()}>
                    {this.isMultipleEditButtonEnabled() ? "Select to Edit" : "Edit"}
                </Button>
                {this.renderInternalComplaintModal()}
                {this.renderPreApprovalDetailMultipleEditModal()}
            </div>
        )
    }
}
